var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      margin: "20px 0"
    }
  }, [_c("div", {
    staticClass: "contBox"
  }, [_vm._v(_vm._s(_vm.$t("拒绝赔付理由")) + ":" + _vm._s(_vm.policyInfo.rejectOpinion))])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };